import React from 'react';
import SEO from '../../components/SEO';

const Dashboard = () => {
  return (
    <div>
      <SEO title="Home" keywords={['OAH', 'application', 'react']} />
    </div>
  );
};
export default Dashboard;
